// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class TopicService {
   $filter: any
   bxService: any
   config: any
   menuManager: any
   results: any
   scope: any
   constructor($filter: any, results: any, bxService: any, config: any, menuManager: any) {
      this.update = this.update.bind(this)
      this.toCamelCase = this.toCamelCase.bind(this)
      this.$filter = $filter
      this.results = results
      this.bxService = bxService
      this.config = config
      this.menuManager = menuManager
      this.scope = {
         topic: {},
         visible: false
      }
      this.results.on('new', () => {
         return this.update()
      })
      this.bxService.on('togglingRecommendations', () => {
         return this.update()
      })
   }

   update() {
      const topics = this.results.data.search.topics || []
      // display only the first topic
      const topic = (this.scope.topic = topics[0] || {})
      topic.displayTopicsInOrder= this.config.data.topics.topics.map((topic: any) => topic.name.substring(0, topic.name.lastIndexOf('_label')))
      for (let index = 0; index < topic.displayTopicsInOrder.length; index++) {
         var value = topic.displayTopicsInOrder[index]
         topic.displayTopicsInOrder[index] = this.toCamelCase(value)
      }

      if (!topic.database_name) { topic.database_name = this.$filter('textMapping')(topic.source_name, 'topic') }
      topic.sourceDisplay = topic.publication_title || topic.database_name
      this.scope.visible = !!topic.title && !this.bxService.showRecommendations && (this.config.data.topics.topics.length > 0)
      topic.hasRelatedTopics = !!(topic.related_topics && topic.related_topics.length && (topic.displayTopicsInOrder.indexOf("relatedTopics") > -1))
      topic.hasResearchGuides = !!(topic.research_guides && topic.research_guides.length && (topic.displayTopicsInOrder.indexOf("recommendedResearchGuides") > -1))
      topic.hasRelevantAuthors = !!(topic.relevant_authors && topic.relevant_authors.length)
      topic.hasLibrarianContactInfo = !!(topic.librarian_contact_info && topic.librarian_contact_info.name && (topic.displayTopicsInOrder.indexOf("suggestedLibrarian") > -1))
      if (topic?.snippet) {
         topic.snippet = topic.snippet.replace(/\\/g, "") // double encoding issue fix / hack
      }

      return this.menuManager.menu.thirdPanel.updateContent('topics', this.scope.visible)
   }

   toCamelCase(value: any) {
      return value.replace(/(\_\w)/g, (param: any) => param[1].toUpperCase())
   }
}

TopicService.$inject = ['$filter', 'dataService', 'bxRecommenderService', 'configService', 'menuManagerService']

angular.module('summonApp.services')
   .service('topicService', TopicService)
